import react,{Component} from 'react';
import { DKLabel, DKButton,showToast,TOAST_TYPE, DKSpinner,DKCalendar,DKIcon,DKIcons,DKLine,DKInput,INPUT_VIEW_DIRECTION,Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE } from '../../../../constants/Constant';
import PayrollService from '../../../../services/PayrollService';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
export default class NEC1099 extends Component{
    selectedUser = [];
    formType = 'form-1099-nec';
    constructor(props){
        super(props)
        this.state={
            users:[],
            canValidate:false,
            contractorList: true
        }
        this.getUsers();
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    async getUsers(){
        const response = await PayrollService.getContractorList();
        if(response['status'] == 'OK') {
            
            this.setState({
                users:response['users'],
                
            })
        }
        this.setState({
            contractorList: false,
            
        })
    }
    export(){
        this.setState({...this.state})
        if(this.selectedUser.length == 0) {
            this.setState(
                {
                    ...this.state,
                    canValidate:true
                }
            )
            return
        }
        let users = []
        let fileName = this.formType;
        this.selectedUser.forEach(ind=>{
            users.push(this.state.users[ind].userId)
            fileName = `${this.formType}_${this.state.users[ind].employeeId}_${this.state.users[ind].firstName}_${this.state.users[ind].lastName}` 
        })
        
        ReportService.downloadForm(users,this.formType).then(
            (response) => {
                
                saveAs(response,fileName);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        )
    }
    render(){
        return(
            <div className="parent-width">
                <DKLabel text="1099 (NEC)" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="1099 (NEC)" className="fw-m fs-l p-l" />
                    <DKLine  className="bg-gray3  "/>
                    <div className="d-flex p-h-l">
                        <div className="" style={{width:'35%'}}>
                        {this.state.contractorList && <div style={{marginLeft : "-348px", marginBottom : "-22px"}}><DKSpinner className="" /></div>}
                        <DKInput
                            title="Contractor"
                            value={this.selectedUser}
                            type={INPUT_TYPE.SELECT}
                            required={true}
                            canValidate={this.state.canValidate}
                            readOnly={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={this.state.users.map(res=>(`${res.firstName} ${res.lastName}` ))}
                            errorMessage="Please select contractor"
                            onChange={(value)=>{
                                this.selectedUser = value
                            }}
                            />
                        </div>
                        
                        
                        <div className="mb-xs mr-l" style={{marginTop: '25px'}}>
                            <DKButton
                            title="DOWNLOAD FORM"
                            icon={DKIcons.white.ic_download}
                            className="bg-app text-white ml-l"
                            onClick={()=>{
                                this.export();
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}